<template>
  <div  :value="value" v-show="showPop">
    <van-popup v-model="showPop" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        v-model="types"
        :columns="pickerList"
        value-key="deptName"
        @confirm="typeChange"
        @cancel="showPop = !showPop"
      />
    </van-popup>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        showPop:false,
        pickerList:[
          {
            deptName:'请选择',
            deptId:''
          }
        ],
        types:'',
        times:1
      }
    },
    props:{
      value:{
        type:Boolean,
        default:false
      },
      typeId:''
    },
    watch:{
      value(val){
        this.showPop = val
      },
      showPop(val){
        this.$emit('input',val)
      },
      typeId(val){
        console.log(val)
        this.types = val
      }
    },
    methods:{
      typeChange(e){
        this.showPop = false
        this.$emit('getShop',e)
      },
      getCols(){
        this.$api.getDealerList({
          salesId:this.$wxuserUtil.getUserId(),
        }).then(response=>{
          this.pickerList =this.pickerList.concat(response.data)
        })
      }

    },
    created(){
      this.getCols()
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/reports/components/shops.vue